// import video from '../../../Assets/video/aaphotobooth360video.mp4';
import video from '../../../Assets/img/aagif.gif';

const Banner = () => {
  return (
    <section className="relative flex items-center justify-center">
        <div className="mt-[220px] sm:mt-0 text-center block absolute px-4 pt-6 pb-10 left-[auto] right-[auto] text-[#fff] z-[2] rounded-xl ">
        <div className="flex flex-col gap-3 sm:gap-[40px] items-center justify-center">
            <h1 className='text-[24px] leading-[32px] sm:text-[60px] sm:leading-[72px]'>  AA 360 Photo Booth </h1>
            <p className="uppercase font-poppins-thin"> 
                NOT YOUR AVERAGE PHOTO BOOTH SERVICES
            </p>
            <a 
                href='#' target="_blank" 
                className="uppercase font-poppins-medium text-[#000] text-[14px] sm:text-[18px] bg-[#fff] border-[2px] sm:border-[6px] border-[#000] px-[14px] sm:px-[32px] py-[8px] sm:py-[16px] rounded-[40px] z-[1]"> 
                Reserve Now
            </a>
        </div>
        </div>
        <div className="bg-video w-full lg:max-w-[1280px] sm:h-full sm:min-h-[500px]">
            {/* <video src={video} className="w-[inherit]" autoPlay muted loop type="video/webm"></video> */}
            <img src={video} alt="GIF" className="absolute top-0 left-0 w-[inherit]" />
        </div>
    </section>
  )
}

export default Banner